const campaignSubsellerNomination = {
	title: 'Nominace obchodníků',
};

const table = {
	tableSellerHeader: 'Obchodník',
	tableSubsellerHeader: 'Podobchodník',
};

export default {
	...campaignSubsellerNomination,
	...table,
};
